import { useState, useEffect } from "react";
import { get } from "lodash";
import { atob } from "isomorphic-base64";

const useElectionUser = () => {
  const [loggedOut, setLoggedOut] = useState(true);
  const [UserId, setUserId] = useState("");
  const [isAppView, setIsAppView] = useState(false);
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    const params = new URLSearchParams(window && window.location && window.location.search);
    const isApp = params.get("source") === "app";

    if (isApp) {
      setIsAppView(true);
      const rawId = params.get("id") || "";
      try {
        const decoded = rawId ? atob(rawId) : "";
        console.log("Raw user id from params:", rawId);
        setUserId(decoded);
        setLoggedOut(!decoded);
      } catch (e) {
        console.error("Failed to decode user id:", e);
        setUserId("");
        setLoggedOut(true);
      }
      setIsReady(true); // ✅ app branch — sync, so fine here
    } else {
      global.userPromise.catch(() => ({})).then(user => {
        const uid = user ? get(user, ["userId"], "") : "";
        const isLoggedOut = user ? get(user, ["loggedOut"], true) : true;
        setUserId(uid);
        setLoggedOut(isLoggedOut);
        setIsReady(true); // ✅ moved inside .then() — fires after UserId is set
      });
    }
    // ❌ removed setIsReady(true) from here
  }, []);

  return { loggedOut, UserId, isAppView, isReady };
};

export default useElectionUser;
